import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";
import { globalAlert, globalLoader } from "../../actions/commonActions";
import { superAdminUpdatePassword } from "../../superadmin/_actions";
import { adminUpdatePassword } from "../../admin/_actions";

const ChangePasswordModal = (props) => {
  const { t } = useTranslation();
  const passwordLength = props?.passwordLength > 0 ? props?.passwordLength : 6;
  const [currentPassword, setCurrentPassword] = useState("");
  const [currentPasswordEmpty, setCurrentPasswordEmpty] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordEmpty, setNewPasswordEmpty] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordEmpty, setConfirmPasswordEmpty] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [minSixChar, setMinSixChar] = useState(false);
  const [oneVarIncluded, setOneVarIncluded] = useState(false);
  const [numberIncluded, setNumberIncluded] = useState(false);
  const [specialCharacter, setSpecialCharacter] = useState(false);
  const [currentPasswordVisible, setCurrentPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setconfirmPasswordVisible] = useState(false);

  const handleCurrPassChange = (evt) => {
    setCurrentPassword(evt.target.value);
    if (evt.target.value) setCurrentPasswordEmpty(false);
  };

  const handleNewPassChange = (evt) => {
    let val = evt.target.value;
    let containsNumber = /\d+/; // eslint-disable-next-line
    let specailChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    let variableChar = /[A-z]/;
    if (variableChar.test(val)) {
      setOneVarIncluded(true);
    } else {
      setOneVarIncluded(false);
    }
    if (containsNumber.test(val)) {
      setNumberIncluded(true);
    } else {
      setNumberIncluded(false);
    }
    if (specailChar.test(val)) {
      setSpecialCharacter(true);
    } else {
      setSpecialCharacter(false);
    }
    if (val.length < passwordLength) {
      setMinSixChar(false);
    } else {
      setMinSixChar(true);
    }

    setNewPassword(evt.target.value);
    if (evt.target.value) setNewPasswordEmpty(false);
  };

  const handleConfirmPassChange = (evt) => {
    setConfirmPassword(evt.target.value);
    // Jab user type kare toh errors ko hide karein
    if (evt.target.value) {
      setConfirmPasswordEmpty(false);
      setPasswordMatch(true);
    }
  };

  const handleValidation = () => {
    let flag = true;
    if (!currentPassword) {
      setCurrentPasswordEmpty(true);
      flag = false;
    }
    if (!newPassword) {
      setNewPasswordEmpty(true);
      flag = false;
    }
    if (!confirmPassword) {
      setConfirmPasswordEmpty(true);
      flag = false;
    }
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      setPasswordMatch(false);
      flag = false;
    }
    return flag;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let valid = await handleValidation();
    if (valid) {
      try {
        globalLoader(true);
        let obj = {
          currentPassword: currentPassword,
          newPassword: newPassword,
        };
        let res;

        if (props?.roleType === "superadmin") {
          res = await superAdminUpdatePassword(obj);
        } else if (props?.roleType === "admin") {
          res = await adminUpdatePassword(obj);
        }
        globalLoader(false);
        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message); // eslint-disable-next-line
          props?.closeModal();
        } else {
          globalAlert("error", res?.data?.message);
        }
      } catch (err) {
        globalLoader(false);
      }
    }
  };

  return (
    <Modal
      open={props?.open}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      center
      classNames={{ modal: "modal-own", root: "modal-own-wrapper" }}
    >
      <div className="px-3">
        <p className=" primary-color h4 py-3 font-weight-bold text-center">
          {t("common.changePassword.title")}
        </p>
        <form className="form-own" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12 col-lg-6">
              {/* CURRENT PASSWORD FIELD */}
              <div className="form-own-group">
                <label htmlFor="currentPassword" className="form-own-label">
                  {t("common.changePassword.currentPasswordLabel")}{" "}
                  <span className="color-red">*</span>
                </label>
                <div className="position-relative">
                  <input
                    className="form-control m-0"
                    type={currentPasswordVisible ? "text" : "password"}
                    name="currentPassword"
                    id="currentPassword"
                    placeholder={t(
                      "common.changePassword.currentPasswordPlaceholder"
                    )}
                    onChange={(evt) => handleCurrPassChange(evt)}
                    value={currentPassword}
                    style={{ paddingRight: "40px" }}
                  />
                  <div
                    className="cursor position-absolute d-flex align-items-center"
                    onClick={() => {
                      setCurrentPasswordVisible((current) => !current);
                    }}
                    style={{ top: 0, bottom: 0, right: "15px" }}
                  >
                    {currentPasswordVisible ? (
                      <i className="far fa-eye"></i>
                    ) : (
                      <i className="far fa-eye-slash"></i>
                    )}
                  </div>
                </div>
                <div className="error-text">
                  {!currentPassword && currentPasswordEmpty && (
                    <span>
                      {t("common.changePassword.currentPasswordRequired")}
                    </span>
                  )}
                </div>
              </div>

              {/* NEW PASSWORD FIELD */}
              <div className="form-own-group">
                <label htmlFor="newPassword" className="form-own-label">
                  {t("common.changePassword.newPasswordLabel")}{" "}
                  <span className="color-red">*</span>
                </label>
                <div className="position-relative">
                  <input
                    className="form-control m-0"
                    type={newPasswordVisible ? "text" : "password"}
                    name="newPassword"
                    id="newPassword"
                    placeholder={t(
                      "common.changePassword.newPasswordPlaceholder"
                    )}
                    onChange={(evt) => handleNewPassChange(evt)}
                    value={newPassword}
                    style={{ paddingRight: "40px" }}
                  />
                  <div
                    className="cursor position-absolute d-flex align-items-center"
                    onClick={() => {
                      setNewPasswordVisible((current) => !current);
                    }}
                    style={{ top: 0, bottom: 0, right: "15px" }}
                  >
                    {newPasswordVisible ? (
                      <i className="far fa-eye"></i>
                    ) : (
                      <i className="far fa-eye-slash"></i>
                    )}
                  </div>
                </div>
                <div className="error-text">
                  {!newPassword && newPasswordEmpty && (
                    <span>
                      {t("common.changePassword.newPasswordRequired")}
                    </span>
                  )}
                </div>
              </div>

              {/* CONFIRM PASSWORD FIELD */}
              <div className="form-own-group">
                <label htmlFor="confirmPassword" className="form-own-label">
                  {t("common.changePassword.confirmPasswordLabel")}{" "}
                  <span className="color-red">*</span>
                </label>
                <div className="position-relative">
                  <input
                    className="form-control m-0"
                    type={confirmPasswordVisible ? "text" : "password"}
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder={t(
                      "common.changePassword.confirmPasswordPlaceholder"
                    )}
                    onChange={(evt) => handleConfirmPassChange(evt)}
                    value={confirmPassword}
                    style={{ paddingRight: "40px" }}
                  />
                  <div
                    className="cursor position-absolute d-flex align-items-center"
                    onClick={() => {
                      setconfirmPasswordVisible((current) => !current);
                    }}
                    style={{ top: 0, bottom: 0, right: "15px" }}
                  >
                    {confirmPasswordVisible ? (
                      <i className="far fa-eye"></i>
                    ) : (
                      <i className="far fa-eye-slash"></i>
                    )}
                  </div>
                </div>
                {/* FIXED ERROR TEXT LOGIC */}
                <div className="error-text">
                  {!confirmPassword && confirmPasswordEmpty ? (
                    <span>
                      {t("common.changePassword.confirmPasswordRequired")}
                    </span>
                  ) : !passwordMatch ? (
                    <span>
                      {t("common.changePassword.passwordsDoNotMatch")}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <p className="primary-color font-12 pt-4">
                {t("common.changePassword.helperText")}
              </p>
              <div className="password-helper pt-4">
                <ul className="list-unstyled helper-list font-12">
                  <li className={`${minSixChar ? "active" : ""}`}>
                    {t("common.changePassword.minChars", {
                      count: passwordLength,
                    })}
                  </li>
                  <li className={`${oneVarIncluded ? "active" : ""}`}>
                    {t("common.changePassword.atLeastOneVariable")}
                  </li>
                  <li className={`${numberIncluded ? "active" : ""}`}>
                    {t("common.changePassword.atLeastOneNumber")}
                  </li>
                  <li className={`${specialCharacter ? "active" : ""}`}>
                    {t("common.changePassword.atLeastOneSpecial")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="form-own col-12">
              <div className="admin-btn mr-2">
                <button
                  onClick={() => props.closeModal()}
                  className="btn secondary-btn"
                  type="button"
                >
                  {t("common.changePassword.cancelButton")}
                </button>
                <button type="submit" className="btn primary-btn ml-2">
                  {t("common.changePassword.submitButton")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;